// Packages
import React from "react"

// Components
import Modal from "@components/team-tools/seim-kirk-calendar-modal"
import SEO from "@components/global/seo"

const SeimKirkCalendar = props => {
  const team = [
    {
      fullName: "Stacey Seim",
      firstName: "Stacey",
      lastName: "Seim",
      calendarLink: "https://calendly.com/staceyseim",
      nmls: "116909",
      licenses: ["VA", "NC", "MD", "DC", "DE"],
    },
    {
      fullName: "Matthew Kirk",
      firstName: "Matthew",
      lastName: "Kirk",
      calendarLink: "https://calendly.com/matthewjkirk",
      nmls: "947887",
      licenses: ["VA", "NC", "TN", "FL", "PA"],
    },
  ]
  return (
    <>
      <div style={{ margin: 0, padding: 0, height: "100%" }}>
        <Modal team={team} />
      </div>
    </>
  )
}

// Meta tags
export const Head = () => {
  return (
    <SEO
      title={`Team Seim Kirk Calendar`}
      slug={`seim-kirk-calendar`}
      hidden={true}
    />
  )
}

export default SeimKirkCalendar
